export const POSES = {
  INIT: 'init',
  INIT_MOBILE: 'initMobile',
  VISIBLE: 'visible',
  VISIBLE_MOBILE: 'visibleMobile',
};
